export const LuFrom = `Lu do Magalu`;
export const SocialMedia = `nas redes sociais`;